import React, { useState, useEffect, useRef } from 'react'
import './Jv.css'
import './Fe.css'
import logo from '../image/logo.png'
import step1 from '../image/jv-steps-1.jpg'
import step2 from '../image/jv-steps-2.jpg'
import step3 from '../image/jv-steps-3.jpg'
import benefits from '../image/jv-benefits-1.jpg'
import compliance from '../image/jv-compliance-1.jpg'
import traffic1 from '../image/jv-traffic-sources-1.jpg'
import traffic2 from '../image/jv-traffic-sources-2.jpg'
import traffic3 from '../image/jv-traffic-sources-3.jpg'
import traffic4 from '../image/jv-traffic-sources-4.jpg'
import traffic5 from '../image/jv-traffic-sources-5.jpg'
import traffic6 from '../image/jv-traffic-sources-6.jpg'
import fedemovideo from '../image/fe-demo.mp4'
import demothumbnail from '../image/demo-thumbnail.png'
import promoteTrustImage from '../image/jv-promote-trust.jpg'
// import jvVideo from '../image/jv-demo.mp4'
import OfferSection from '../image/jv-offer-section.png'

const navItems = [
  { label: 'Demo Video', action: 'demo' },
  { label: 'Swipes', action: 'swipes' },
  { label: 'JV Doc', action: 'jvdoc' },
  { label: 'Funnel', action: 'funnel' },
]

const JV_AFFILIATE_BULLETS = [
  'High-converting all-in-one system (not just a data tool)',
  'Multiple upsells + higher EPC potential',
  'One-time pricing = easy to convert',
  'Beginner-friendly + clear use case',
  'Works across multiple niches & audiences',
  'Includes AI + Outreach + CRM features (high perceived value)',
  'Solves real business problem (lead generation + follow-up)',

]

/** MP4 for the JV section `poster` is `jv-video.jpg`; add `public/jv-demo.mp4` or set a full video URL. */
// const JV_DEMO_VIDEO_SRC = `${process.env.PUBLIC_URL || ''}/jv-demo.mp4`

const JV_PROMOTE_TRUST_POINTS = [
  {
    icon: '🛡️',
    strong: 'Solves a real business problem (finding, managing & converting leads)',

  },
  {
    icon: '👁️',
    strong: 'Simple & easy-to-understand all-in-one system (no confusion for buyers) ',
  },
  {
    icon: '🌐',
    strong: 'High-demand B2B + lead generation market',
  },
  {
    icon: '📄',
    strong: 'High perceived value with 2.0 features (AI + Outreach + CRM system) ',
  },
  {
    icon: '✉️',
    strong: 'Clean, compliant & beginner-friendly funnel (easy approvals & scaling) ',
  },
]

const JV_PROMOTE_TRUST_IMAGE =
  'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=480&h=480&q=80'

const JV_TRAFFIC_SOURCES = [
  {
    img: traffic1,
    title: 'YouTube Reviews, Tutorials & Demo Videos',
    alt: 'Person reviewing email and analytics on a laptop',

  },
  {
    img: traffic2,
    title: 'SEO Blog Content & Lead Generation Articles',
    alt: 'Creator with microphone recording video content',

  },
  {
    img: traffic3,
    title: 'Email Marketing (Permission-Based Lists Only)',
    alt: 'Business professionals collaborating with social and data context',

  },
  {
    img: traffic4,
    title: 'Facebook, LinkedIn & B2B Community Promotion',
    alt: 'Person using a smartphone with social apps',

  },
  {
    img: traffic5,
    title: 'Short-Form Content (Reels, TikTok, Shorts)',
    alt: 'Person working on a laptop focused on content and SEO',

  },
  {
    img: traffic6,
    title: 'Bonus Pages & Value-Based Promotions',
    alt: 'Creative professional presenting short-form video content',

  },
]

/* Keep in sync with FE_PAYMENT_PLANS in Fe.js (incl. ctaHref; styles from Fe.css). */
const JV_PAYMENT_PLANS = [
  {
    badge: 'Most Popular',
    badgeTone: 'blue',
    name: 'STARTER ',
    // desc: 'Ideal for solo operators who want lead search, lists & basic outreach in one place.',
    price: '$8.99',
    cta: 'Start with Starter',
    ctaHref: '/2.0jv',
    features: [
      { ok: true, text: 'Find targeted leads (any niche, location, industry)' },
      { ok: true, text: 'Access real business profiles & basic contact data' },
      { ok: true, text: 'Save leads into smart lists' },
      { ok: true, text: 'Tag & organize leads (Hot, Contacted, Follow-up)' },
      { ok: true, text: 'Basic pipeline tracking (New → Contacted)' },
      { ok: true, text: 'Beginner-friendly dashboard' },
      // { ok: false, text: 'No AI outreach system' },
      // { ok: false, text: 'No follow-up automation' },
      // { ok: false, text: 'No exports / CRM sync' },
    ],
  },
  {
    badge: 'Best Value',
    badgeTone: 'purple',
    name: 'Pro Lead Suite',
    // desc: 'For marketers who need faster workflows, AI messaging & stronger list growth.',
    price: '$20',
    cta: 'Go Pro Now',
    ctaHref: '/2.0oto1',
    features: [
      { ok: true, text: 'Everything in Starter' },
      { ok: true, text: 'AI-powered outreach message generator' },
      { ok: true, text: 'Send outreach messages directly' },
      { ok: true, text: 'Schedule automated follow-ups' },
      { ok: true, text: 'Track responses (Interested / No Reply / Not Interested)' },
      { ok: true, text: 'Save & reuse message templates' },
      { ok: true, text: 'Better limits for outreach & daily usage' },
      // { ok: false, text: 'No advanced export / CRM tools' },
      // { ok: false, text: 'No team collaboration' },
    ],
  },
  {
    badge: 'Premium',
    badgeTone: 'green',
    name: 'AGENCY EDITION (OTO2)',
    // desc: 'Built for agencies managing multiple clients, lists & outreach from one dashboard.',
    price: '$59',
    cta: 'Get Agency Access',
    ctaHref: '/2.0oto2',
    features: [
      { ok: true, text: 'Everything in Pro' },
      { ok: true, text: 'Export leads (CSV, Google Sheets, CRM-ready)' },
      { ok: true, text: 'Advanced lead management & segmentation' },
      { ok: true, text: 'Full pipeline tracking (New → Contacted → Closed)' },
      { ok: true, text: 'Activity tracking & lead history' },
      { ok: true, text: 'Multi-user access (team roles)' },
      { ok: true, text: 'Shared lists & team collaboration' },
      { ok: true, text: 'Central dashboard for leads + outreach + activity' },
    ],
  },
  {
    badge: 'Scale',
    badgeTone: 'teal',
    name: 'UNLIMITED EDITION (OTO3)',
    // desc: 'Maximum capacity for power users & teams who live inside their outreach stack.',
    price: '$98',
    cta: 'Get Unlimited Now',
    ctaHref: '/2.0oto3',
    features: [
      { ok: true, text: 'Everything in Agency' },
      { ok: true, text: 'Unlimited lead searches & usage' },
      { ok: true, text: 'Unlimited outreach & follow-ups' },
      { ok: true, text: 'Unlimited exports & data access' },
      { ok: true, text: 'No usage restrictions (full system unlocked)' },
      { ok: true, text: 'Best for agencies & high-volume users' },
      { ok: true, text: 'Commercial use (client work ready)' },
      { ok: true, text: 'Priority performance & scaling support' },
    ],
  },
]

export default function Jv() {
  const [navOpen, setNavOpen] = useState(false)
  const affiliateCardRef = useRef(null)
  const demoVideoSectionRef = useRef(null)
  const funnelOfferSectionRef = useRef(null)

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') setNavOpen(false)
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [])

  useEffect(() => {
    const mq = window.matchMedia('(min-width: 769px)')
    const onChange = () => {
      if (mq.matches) setNavOpen(false)
    }
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [])

  useEffect(() => {
    if (!navOpen) return
    const mq = window.matchMedia('(max-width: 768px)')
    if (!mq.matches) return
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = prev
    }
  }, [navOpen])

  const closeNav = () => setNavOpen(false)
  const scrollToDemoVideoSection = () => {
    closeNav()
    demoVideoSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
  const scrollToAffiliateCard = () => {
    closeNav()
    affiliateCardRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
  const scrollToFunnelSection = () => {
    closeNav()
    funnelOfferSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
  const openEmailSwipesPdf = () => {
    closeNav()
    window.open('/2.0pdf/swipes', '_blank', 'noopener,noreferrer')
  }
  const openJvDocPdf = () => {
    closeNav()
    window.open('/2.0pdf/jvdoc', '_blank', 'noopener,noreferrer')
  }

  return (
    <div className="jv-page">
      <header className="jv-header">
        <div className="jv-header__inner">
          <div className="jv-header__top">
            <a className="jv-brand" href="/jv" aria-label="Leadszora JV page">
              <img
                className="fe-mail-suite__logo-icon"
                src={logo}
                alt="Responsible data use and compliance with business contact regulations"
                loading="lazy"
                width={230}
                height={100}
              />
            </a>

            <button
              type="button"
              className={navOpen ? 'jv-header__menu-btn jv-header__menu-btn--open' : 'jv-header__menu-btn'}
              aria-expanded={navOpen}
              aria-controls="jv-primary-nav"
              aria-label={navOpen ? 'Close menu' : 'Open menu'}
              onClick={() => setNavOpen((o) => !o)}
            >
              <span className="jv-header__menu-bars" aria-hidden="true">
                <span className="jv-header__bar" />
                <span className="jv-header__bar" />
                <span className="jv-header__bar" />
              </span>
            </button>
          </div>

          <nav
            id="jv-primary-nav"
            className={navOpen ? 'jv-nav jv-nav--open' : 'jv-nav'}
            aria-label="JV navigation"
          >
            {navItems.map((item) => (
              <button
                key={item.label}
                type="button"
                className="jv-nav__link"
                onClick={
                  item.action === 'demo'
                    ? scrollToDemoVideoSection
                    : item.action === 'funnel'
                      ? scrollToFunnelSection
                      : item.action === 'swipes'
                        ? openEmailSwipesPdf
                      : item.action === 'jvdoc'
                        ? openJvDocPdf
                      : closeNav
                }
              >
                {item.label}
              </button>
            ))}
            <button type="button" className="jv-nav__btn" onClick={scrollToAffiliateCard}>
              Get Affiliate Link
            </button>
          </nav>
        </div>
        {navOpen ? (
          <button
            type="button"
            className="jv-header__backdrop"
            aria-label="Close menu"
            tabIndex={-1}
            onClick={closeNav}
          />
        ) : null}
      </header>

      <main className="jv-main">
        <section className="jv-offer-highlight">
          <div className="jv-offer-highlight__pill">
            Discover, Manage & Convert High-Quality
            <span> B2B Leads Faster With AI
            </span>
          </div>

          <h1 className="jv-offer-highlight__title">
            Promote A High-Converting
            <span> AI Lead Generation + Outreach System & Earn Easy
            </span>
          </h1>

          <p className="jv-offer-highlight__subtitle">
            This is a complete lead generation + lead management + outreach system designed for real business use — not a get-rich-quick scheme

          </p>

          <div className="jv-offer-highlight__mid-pill" onClick={scrollToAffiliateCard} >AI-Powered Lead Finder + Smart Lists + Outreach + Follow-Up System
          </div>

          {/* <p className="jv-offer-highlight__body">
            Most tools only give data… leadszora helps users find leads, organize them, contact them, and track results — all in one simple dashboard


          </p> */}
          {/* <p className="jv-offer-highlight__body1">One-time payment + high-value feature stack makes leadszora extremely easy to sell and convert
          </p> */}

          {/* <p className="jv-offer-highlight__body jv-offer-highlight__body--small">
            Built for marketers, agencies, freelancers & sales teams to find leads, manage them with smart lists, run outreach campaigns, and track conversions — all from one platform

          </p> */}

          <div className="jv-offer-highlight__footer-pill">
            One-Time Offer (High Conversion)
            <span>•</span>
            AI + Outreach + CRM System (All-in-One)
            <span>•</span>
            High-Demand B2B Market
            <span>•</span>
            Beginner-Friendly + Easy To Promote
            <span>•</span>
            Includes Smart Lists, Outreach & AI Messaging
          </div>
        </section>

        <section className="jv-scale-section">
          <h2 className="jv-scale-section__title">
            Promote Smarter — Earn More with <span> High-Converting AI Lead Generation + Outreach System</span>
          </h2>
          <p className="jv-scale-section__subtitle">
            Help users find targeted leads, organize them with smart lists, run outreach campaigns, and track follow-ups — all using AI-powered workflows

          </p>

          <div className="jv-launch-card">
            <div className="jv-launch-card__line" />
            <h3 className="jv-launch-card__title"> 🚀 leadszora 2.0 Is Live — Funnel Optimized, Feature-Rich & Built To Convert
            </h3>
            <p className="jv-launch-card__desc">
              Official launch is live — now upgraded with powerful new features to boost conversions & user results

            </p>

            <div className="jv-launch-grid">
              <article className="jv-launch-grid__item jv-launch-grid__item--blue">
                <span>High-Converting Funnel + Upgraded Value Sta

                </span>
              </article>
              <article className="jv-launch-grid__item jv-launch-grid__item--purple">
                <span>Affiliate Links Activated + Instant Promotion Access

                </span>

              </article>
              <article className="jv-launch-grid__item jv-launch-grid__item--cyan">
                <span>Tracking, Conversions & User Activity Insights Enabled

                </span>
              </article>
              <article className="jv-launch-grid__item jv-launch-grid__item--pink">
                <span>Optimized OTO Funnel (Higher EPC with 2.0 Features)

                </span>
              </article>
            </div>

            <div className="jv-launch-card__status">
              <span className="jv-launch-card__dot" aria-hidden="true" />
              Platform Live
              <span>•</span> 2.0 Features Activated
              <span>•</span> Ready For High Conversions


            </div>
          </div>
        </section>

        <section className="jv-affiliate-section" id="affiliate-link">
          <div className="jv-affiliate-card" ref={affiliateCardRef}>
            <p className="jv-affiliate-card__kicker">Affiliate Partner Access</p>
            <p className="jv-affiliate-card__headline">
              This page is for affiliates. Promote leadszora 2.0 — an AI-powered lead generation + outreach system — and earn commissions on every sale

            </p>

            <div className="jv-affiliate-card__badge" aria-label="Warrior Plus">WarriorPlus
            </div>

            <a className="jv-affiliate-card__link-btn jv-affiliate-card__link-btn--highlight" href="https://warriorplus.com/as/o/sd90jm" target="_blank" rel="noopener noreferrer">
              <span>🔗Get Your Affiliate Link & Start Earning Today</span>
              <span className="jv-affiliate-card__link-arrow" aria-hidden="true">→</span>
            </a>

            <p className="jv-affiliate-card__note">
              Promote using email, ads, or content — just follow simple compliance & permission-based messaging guidelines

            </p>
            {/* <div className="jv-affiliate-card__points" aria-label="Affiliate highlights">
              <span>High EPC Potential</span>
              <span>Manual Approval</span>
              <span>Compliance Friendly</span>
            </div> */}
            </div>

          <p className="jv-affiliate-section__approve">
            Affiliates are manually approved to ensure high-quality traffic, better conversions, and platform compliance

          </p>

          <div className="jv-affiliate-section__actions">
            <a href="/2.0pdf/jvdoc" target="_blank" rel="noopener noreferrer">📄 JV Doc</a>
            <a href="https://leadszora.com/2.0fe/">🚀 Sales Page Preview</a>
            <a href="/2.0pdf/swipes" target="_blank" rel="noopener noreferrer">✉️ Email Swipes</a>
          </div>
        </section>

        <section className="jv-steps-section" aria-labelledby="jv-steps-heading">
          <div className="jv-steps-section__intro">
            <span className="jv-steps-section__badge">3 SIMPLE STEPS</span>
            <h2 id="jv-steps-heading" className="jv-steps-section__title">
              Start Promoting leadszora 2.0 In
              <span>3 Simple Steps</span>
            </h2>
            <p className="jv-steps-section__subtitle">
              Start earning by promoting a high-demand AI lead generation + outreach system — no complex setup needed

            </p>
          </div>

          <div className="jv-steps-row">
            <div className="jv-steps-row__visual">
              <div className="jv-steps-visual">
                <img
                  src={step1}
                  alt=""
                  className="jv-steps-visual__img"
                />
                {/* <div className="jv-steps-visual__float" aria-hidden="true">
                  <span className="jv-steps-visual__float-icon">🛡️</span>
                  <span>Secure sign-up</span>
                </div> */}
              </div>
            </div>
            <div className="jv-steps-row__card">
              <article className="jv-steps-card">
                <div className="jv-steps-card__top">
                  {/* <span className="jv-steps-card__icon" aria-hidden="true">
                    ✉️
                  </span> */}
                  <span className="jv-steps-card__step-pill">STEP 1</span>
                </div>
                <h3 className="jv-steps-card__title">Get Your Affiliate Link Instantly
                </h3>
                <ul className="jv-steps-card__list">
                  <li>Get instant access to your affiliate link from WarriorPlus
                  </li>
                  <li>Start promoting immediately with a ready-to-convert funnel
                  </li>
                </ul>
              </article>
            </div>
          </div>

          <div className="jv-steps-row jv-steps-row--reverse">
            <div className="jv-steps-row__visual">
              <div className="jv-steps-visual">
                <img
                  src={step2}
                  alt=""
                  className="jv-steps-visual__img"
                />
                {/* <div className="jv-steps-visual__float jv-steps-visual__float--dark" aria-hidden="true">
                  <span className="jv-steps-visual__float-icon">✉️</span>
                  <span>Dashboard</span>
                </div> */}
              </div>
            </div>
            <div className="jv-steps-row__card">
              <article className="jv-steps-card">
                <div className="jv-steps-card__top">
                  {/* <span className="jv-steps-card__icon" aria-hidden="true">
                    🔒
                  </span> */}
                  <span className="jv-steps-card__step-pill">STEP 2</span>
                </div>
                <h3 className="jv-steps-card__title">Use Done-For-You High-Converting Promo Materials
                </h3>
                <ul className="jv-steps-card__list">
                  <li>Get access to email swipes, banners & proven marketing angles
                  </li>
                  <li> Promote a product with strong 2.0 features (AI + Outreach + CRM system)
                  </li>
                </ul>
              </article>
            </div>
          </div>

          <div className="jv-steps-row">
            <div className="jv-steps-row__visual">
              <div className="jv-steps-visual">
                <img
                  src={step3}
                  alt=""
                  className="jv-steps-visual__img"
                />
                {/* <div className="jv-steps-visual__float" aria-hidden="true">
                  <span className="jv-steps-visual__float-icon">📋</span>
                  <span>All Leads</span>
                </div> */}
              </div>
            </div>
            <div className="jv-steps-row__card">
              <article className="jv-steps-card">
                <div className="jv-steps-card__top">
                  {/* <span className="jv-steps-card__icon" aria-hidden="true">
                    🚀
                  </span> */}
                  <span className="jv-steps-card__step-pill">STEP 3</span>
                </div>
                <h3 className="jv-steps-card__title">Earn Commissions Promoting A High-Value AI System
                </h3>
                <ul className="jv-steps-card__list">
                  <li>Earn commissions from a high-converting funnel with upgraded features
                  </li>
                  <li>Higher perceived value = better conversions & EPC
                  </li>
                </ul>
                <a className="jv-steps-card__cta jv-steps-card__cta--animated" onClick={scrollToAffiliateCard}>
                  <span>Get Your Affiliate Link & Start Promoting Now</span>
                  <span className="jv-steps-card__cta-arrow" aria-hidden="true">→</span>
                </a>
              </article>
            </div>
          </div>
        </section>

        <section className="jv-benefits-section" aria-labelledby="jv-benefits-heading">
          <div className="jv-benefits-section__header">
            <span className="jv-section-pill">High Converting Affiliate Offer</span>
            <h2 id="jv-benefits-heading" className="jv-benefits-section__title">
              Earn Commissions Promoting A High-Demand
              <span> AI Lead Generation + Outreach System
              </span>
            </h2>
            <p className="jv-benefits-section__subtitle">
              Discover why affiliates are choosing leadszora 2.0 — and how its upgraded feature stack helps increase conversions & earnings

            </p>
          </div>

          <div className="jv-split">
            <div className="jv-split__visual jv-split__visual--blue-glow">
              <img src={benefits} alt="" className="jv-split__img" />
            </div>
            <div className="jv-split__body">
              <div className="jv-kicker jv-kicker--blue">
                <span aria-hidden="true">🏅</span> Why Affiliates Are Choosing Leadszora
              </div>
              <h3 className="jv-split__heading">
                Why Affiliates Are Choosing leadszora 2.0

              </h3>
              <ul className="jv-checklist">
                {JV_AFFILIATE_BULLETS.map((line) => (
                  <li key={line}>{line}</li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        <section className="jv-compliance-section" aria-labelledby="jv-compliance-heading">
          <div className="jv-split jv-split--reverse">
            <div className="jv-split__body">
              <div className="jv-kicker jv-kicker--green">
                <span aria-hidden="true">🛡️</span> LEGAL &amp; COMPLIANCE
              </div>
              <h3 id="jv-compliance-heading" className="jv-split__heading">
                Compliance, Transparency & Affiliate Guidelines

              </h3>
              <span className="jv-compliance-pill">Critical for Approval</span>

              <div className="jv-compliance-box jv-compliance-box--accent">
                leadszora uses publicly available business data and is designed for ethical lead research and outreach

              </div>

              <p className="jv-compliance-star">
                <span aria-hidden="true">⭐</span> Users must follow standard compliance practices while using the platform

              </p>

              <div className="jv-compliance-grid">
                <div className="jv-compliance-box">GDPR (EU data protection)
                  : European data protection</div>
                <div className="jv-compliance-box">CAN-SPAM (email compliance)
                  : US email regulations</div>
              </div>

              <div className="jv-compliance-box">
                Local marketing & data usage laws
                &amp; data usage laws: Country-specific compliance
              </div>

              <div className="jv-compliance-notice">
                <strong>Important:</strong> leadszora is a business tool — results depend on user action, strategy, and execution

              </div>

              <div className="jv-compliance-support">
                <span aria-hidden="true">✉️</span>
                <span>
                  Need help or affiliate support? {' '}
                  <a href="mailto:support@leadszora.com">support@leadszora.com</a>
                </span>
              </div>
            </div>
            <div className="jv-split__visual jv-split__visual--green-glow">
              <img src={compliance} alt="" className="jv-split__img" />
            </div>
          </div>
        </section>

        <section className="jv-final-cta" aria-labelledby="jv-final-cta-heading">
          <div className="jv-final-cta__card">
            <h2 id="jv-final-cta-heading" className="jv-final-cta__title">
              Ready To Promote leadszora 2.0 & Start Earning Commissions?

            </h2>
            <p className="jv-final-cta__subtitle">
              Join affiliates promoting a high-demand AI lead generation + outreach system with strong conversion potential

            </p>
            <a className="jv-final-cta__btn jv-steps-card__cta--animated" onClick={scrollToAffiliateCard}>
              <span>Get Your Affiliate Link & Start Promoting Now</span>
              <span className="jv-steps-card__cta-arrow" aria-hidden="true">→</span>
            </a>
          </div>
        </section>

        <div className="jv-vendor-video-band">
          <section className="jv-vendor-section" aria-labelledby="jv-vendor-heading">
            <h2 id="jv-vendor-heading" className="jv-vendor-section__title">
              About The Team Behind leadszora

            </h2>
            <div className="jv-vendor-section__accent" aria-hidden="true" />
            <div className="jv-vendor-card">
              <p>
                leadszora is built by a team experienced in SaaS, lead generation, and marketing automation
              </p>
              <p> With the 2.0 upgrade, the platform now goes beyond lead generation — helping users manage leads, run outreach, and track results in one system</p>
              <p> The goal is simple: build powerful yet easy-to-use tools that deliver real business outcomes</p>

            </div>
          </section>

          <section className="jv-video-section" aria-labelledby="jv-video-heading" ref={demoVideoSectionRef}>
            <div className="jv-video-section__decor jv-video-section__decor--left" aria-hidden="true">
              <span className="jv-video-section__grid" />
              <span className="jv-video-section__icons">
                <span>🎬</span>
                <span>▶</span>
              </span>
            </div>
            <div className="jv-video-section__decor jv-video-section__decor--right" aria-hidden="true" />

            <div className="jv-video-section__inner">
              <h2 id="jv-video-heading" className="jv-video-section__title">
                See The High-Converting Funnel & System
                <span> In Action</span>
              </h2>

              <div className="jv-video-frame">
                <video
                  className="jv-video-frame__player"
                  controls
                  playsInline
                  preload="metadata"
                  poster={demothumbnail}
                  src={fedemovideo}
                  title="Demo: high-converting funnel and system"
                >
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </section>
        </div>

        <section
          className="jv-funnel-offer-section"
          aria-labelledby="jv-funnel-offer-heading"
          ref={funnelOfferSectionRef}
        >
          <h2 id="jv-funnel-offer-heading" className="jv-funnel-offer-section__headline">
            Simple Funnel — Built To Maximize Conversions & Earnings
          </h2>
         
          <div className="fe-workflow-illustration-card">
            <img
              className="fe-workflow-illustration-card__img"
              src={OfferSection}
              alt="Leadszora workflow illustration using sa2.jpg"
              loading="lazy"
              width={900}
              height={600}
            />
          </div>
        </section>

        <section className="fe-payment-plans" aria-labelledby="jv-payment-plans-heading">
          <div className="fe-payment-plans__inner">
            <h2 id="jv-payment-plans-heading" className="fe-payment-plans__title">
              Choose Your Plan &amp; Start Finding Leads Today
            </h2>
            <p className="fe-payment-plans__sub">
              Simple one-time pricing — no monthly fees, no hidden costs.
            </p>
            <div className="fe-payment-plans__grid">
              {JV_PAYMENT_PLANS.map((plan) => (
                <article key={plan.name} className="fe-payment-plans__card">
                  <span className={`fe-payment-plans__badge fe-payment-plans__badge--${plan.badgeTone}`}>
                    {plan.badge}
                  </span>
                  <h3 className="fe-payment-plans__name">{plan.name}</h3>
                  <p className="fe-payment-plans__desc">{plan.desc}</p>
                  <div className="fe-payment-plans__price-block">
                    <span className="fe-payment-plans__price">{plan.price}</span>
                    <span className="fe-payment-plans__price-note">one-time payment</span>
                  </div>
                  <ul className="fe-payment-plans__features">
                    {plan.features.map((row, idx) => (
                      <li
                        key={idx}
                        className={`fe-payment-plans__feature${row.ok ? '' : ' fe-payment-plans__feature--out'}`}
                      >
                        <span className="fe-payment-plans__feature-ic" aria-hidden="true">
                          {row.ok ? '✓' : '✕'}
                        </span>
                        <span className="fe-payment-plans__feature-txt">{row.text}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="fe-payment-plans__cta-wrap">
                    <a className="fe-payment-plans__cta" href={plan.ctaHref}>
                      <span>{plan.cta}</span>
                      <span className="fe-payment-plans__cta-arrow" aria-hidden="true">
                        →
                      </span>
                    </a>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="jv-promote-trust-section" aria-labelledby="jv-promote-trust-heading">
          <div className="jv-promote-trust-section__header">
            <span className="jv-promote-trust-section__badge">Affiliate-Friendly • High-Converting • Policy-Compliant
            </span>
            <h2 id="jv-promote-trust-heading" className="jv-promote-trust-section__title">
              <span className="jv-promote-trust-section__title-line">Why You Should Promote leadszora 2.0 (AI Lead Generation + Outreach System)
              </span>
              <span className="jv-promote-trust-section__title-green">
                Promote Our Email Funnel System
              </span>
            </h2>
            <p className="jv-promote-trust-section__subtitle">
              Built for long-term growth — a complete lead generation + management + outreach system that affiliates can promote with confidence

            </p>
          </div>

          <div className="jv-promote-trust-section__grid">
            <div className="jv-promote-trust-section__content">
              <ul className="jv-promote-trust-list">
                {JV_PROMOTE_TRUST_POINTS.map((item) => (
                  <li key={item.strong} className="jv-promote-trust-list__item">
                    <span className="jv-promote-trust-list__icon" aria-hidden="true">
                      {item.icon}
                    </span>
                    <span className="jv-promote-trust-list__text">
                      <strong>{item.strong}</strong>
                      {item.rest}
                    </span>
                  </li>
                ))}
              </ul>
              <a className="jv-promote-trust-section__btn jv-steps-card__cta--animated" onClick={scrollToAffiliateCard}>
                <span>Get Your Affiliate Link & Start Promoting</span>
                <span className="jv-steps-card__cta-arrow" aria-hidden="true">→</span>
              </a>
            </div>
            <div className="jv-promote-trust-section__visual">
              <div className="jv-promote-trust-section__avatar-wrap">
                <img
                  src={promoteTrustImage}
                  alt="Professional affiliate partner"
                  className="jv-promote-trust-section__avatar"
                  width={320}
                  height={320}
                />
              </div>
            </div>
          </div>
          <p className="jv-promote-trust-section__end-note">
            Includes Smart Lists, Outreach System, AI Messaging &amp; Follow-Up Tracking{' '}
            <strong>(strong upgrade value)</strong>
          </p>
        </section>

        <section className="jv-traffic-sources-section" aria-labelledby="jv-traffic-sources-heading">
          <h2 id="jv-traffic-sources-heading" className="jv-traffic-sources-section__title">
            Recommended <span>Traffic Strategies</span> To Promote leadszora 2.0

          </h2>
          <p className="jv-traffic-sources-section__subtitle">
            Use these proven traffic methods to promote leadszora — always follow platform policies and compliance guidelines

          </p>

          <ul className="jv-traffic-sources-grid">
            {JV_TRAFFIC_SOURCES.map((card) => (
              <li key={card.title} className="jv-traffic-sources-card">
                <div className="jv-traffic-sources-card__media">
                  <img src={card.img} alt={card.alt} className="jv-traffic-sources-card__img" />
                </div>
                <p className="jv-traffic-sources-card__label">{card.title}</p>
              </li>
            ))}
          </ul>

          <p className="jv-traffic-sources-section__footer">
            leadszora is a business research, lead generation, and outreach platform. It does not guarantee income or specific results. Outcomes depend on user effort, strategy, and execution

          </p>
        </section>
      </main>

      <footer className="jv-site-footer">
        <div className="jv-site-footer__inner">
          <a className="jv-site-footer__brand" href="/jv" aria-label="Leadszora home">
            <img
              className="fe-mail-suite__logo-icon"
              src={logo}
              alt="Responsible data use and compliance with business contact regulations"
              loading="lazy"
              width={230}
              height={120}
            />
          </a>

        </div>

        <div className="jv-site-footer__disclaimer">
          <div className="jv-site-footer__badge">
            <span aria-hidden="true">🛡️</span> Important Disclaimer & Earnings Notice

          </div>
          <p>
            👉 leadszora is a software product designed for lead generation, management, and outreach
          </p>
          <p>
            👉 Earnings and commissions are not guaranteed and depend on individual effort, traffic sources, and marketing strategy
          </p>
          <p>
            👉 This is not a get-rich-quick system — results vary based on how the platform is used
          </p>

        </div>
        <div className="jv-site-footer__disclaimer">
          
          <p>
          Always follow platform policies and compliance guidelines when promoting or using the software

          </p>
         

        </div>

        <div className="jv-site-footer__bar">
          <p className="jv-site-footer__copy">Copyright © Leadszora {new Date().getFullYear()}</p>
          <nav className="jv-site-footer__links" aria-label="Legal">
            <a href="/2.0privacy-policy">Privacy Policy</a>
            <span className="jv-site-footer__sep" aria-hidden="true">
              •
            </span>
            <a href="/2.0Terms-of-Service">Terms</a>
            <span className="jv-site-footer__sep" aria-hidden="true">
              •
            </span>
            <a href="/2.0Earning-Disclaimer">Disclaimer</a>
            <span className="jv-site-footer__sep" aria-hidden="true">
              •
            </span>
            <a href="/2.0Contact-Us">Contact</a>
          </nav>
        </div>
      </footer>
    </div>
  )
}
